import * as R from 'ramda';
import { mapProps, lifecycle, withState, withHandlers } from 'recompose';
import { Form } from 'antd';
import { connect } from 'react-redux';
import message from 'antd/lib/message';

import ManageEmailsModalComp from './manage-emails-modal-comp';
import {
  fetchSubscribeEmails,
  addSubscribeEmail,
  deleteSubscribeEmailById,
} from '../../api/apiko-api';
import { getResErrorMsg } from '../../utils';
import { getUsers } from '../../redux/selectors';

export const ManageEmailsModal = Form.create()(R.compose(
  connect(state => ({
    users: getUsers(state),
  })),
  withState('isFetching', 'setIsFetching', false),
  withState('emails', 'setEmails', []),
  lifecycle({
    componentDidMount() {
      // Fetch on open subscribe emails window
      if (!this.props.emails.length) {
        fetchSubscribeEmails().then(({ emails }) => this.props.setEmails(emails));
      }
    },
  }),
  mapProps(({
    form, emails, setEmails, users, isFetching,
  }) => ({
    form,
    emails,
    isFetching,
    authUser: users[localStorage.getItem('userId')],
    onDeleteEmail: id =>
      deleteSubscribeEmailById(id)
        .then(({ _id }) => {
          message.success('Email successfully removed');
          setEmails([...R.filter(email => email._id !== _id, emails)]);
        })
        .catch((error) => {
          message.error(getResErrorMsg(error));
        }),
    onAddNewEmail: (event) => {
      event.preventDefault();
      if (!isFetching) {
        form.validateFieldsAndScroll((err, value) => {
          if (!err) {
            addSubscribeEmail(value)
              .then((email) => {
                form.resetFields();
                message.success('Email successfully Added');
                setEmails([...emails, { ...email }]);
              })
              .catch((error) => {
                message.error(getResErrorMsg(error));
              });
          } else {
            console.log(err);
          }
        });
      }
    },
  })),
  withHandlers({
    isHardcoded: () => (onlyForCountries = []) => !!onlyForCountries.length,
  }),
)(ManageEmailsModalComp));



// WEBPACK FOOTER //
// ./src/modals/manage-emails-modal/manage-emails-modal.js